import svg from './row-svg/mail-2.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function Mail2Icon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default Mail2Icon;
